export const SET_SORT = 'SET_SORT'

export const setSort = sortOption => ({
    type: SET_SORT,
    sortOption
})